import { MAX_SWIPE_RATIO, ONBOARDING_SWIPE_OFFSET } from '../constants';

/**
 * Предельный сдвиг сообщения при свайпе.
 *
 * Замеряется в момент начала жеста — размеры сообщения могут меняться между
 * свайпами. Сообщение уезжает максимум на долю своей ширины, чтобы часть
 * пузыря осталась на экране. Доля берётся из RS-настройки
 * chats.replies.swipeConfig (useSwipeConfig), по умолчанию MAX_SWIPE_RATIO.
 */
export const getMaxSwipeOffset = (messageElement: HTMLElement, maxSwipeRatio: number = MAX_SWIPE_RATIO): number => {
  const { width } = messageElement.getBoundingClientRect();

  return width * maxSwipeRatio;
};

/**
 * Максимальный сдвиг для онбординга — гарантирует, что хинт остаётся на экране.
 *
 * Входящие (left-aligned): `left` минимален → 80% от ширины сообщения (getMaxSwipeOffset).
 * Исходящие (right-aligned): `left` максимален → фиксированный ONBOARDING_SWIPE_OFFSET.
 */
export const getOnboardingSwipeOffset = (messageElement: HTMLElement): number => {
  const { left } = messageElement.getBoundingClientRect();
  const maxWidthOffset = getMaxSwipeOffset(messageElement);

  return left < maxWidthOffset ? maxWidthOffset : ONBOARDING_SWIPE_OFFSET;
};
